import service from '@/api/implement';
import {loading, handleError} from '@/state/generators/helpers';
import {alert} from "../generators/helpers";

export const state = {
    loading: false,
    pager: {},
    additional: {},
    list: [],
    own: [],
    service: service('implements'),
    realizeLoading: false
}

export const getters = {
    realizeLoading: function (state) {
        return !!state.realizeLoading
    },
    loading: function (state) {
        return !!state.loading
    },
    pager: function (state) {
        return JSON.parse(JSON.stringify(state.pager))
    },
    list: function (state) {
        return state.list
    },
    own: function (state) {
        return state.own
    }
}

export const mutations = {
    'SET_REALIZE_LOADING': function (state, boolean = true) {
        state.realizeLoading = boolean
    },

    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean
    },

    'SET_LIST': function (state, list) {
        state.list = list
    },

    'SET_OWN': function (state, list) {
        state.own = list
    },

    'SET_PAGER': function (state, pager = {}) {
        state.pager = pager
    },

    'SET_ADDITIONAL': function (state, data = {}) {
        state.additional = data
    },
}

export const actions = {
    own: function ({commit, state}, filters) {
        loading(commit)

        return state.service.fetchOwn(filters).then(response => {
            commit('SET_LIST', response.data)
            commit('SET_OWN', response.data)
            commit('SET_PAGER', response.meta)
            commit('SET_ADDITIONAL', response.additional)
            loading(commit, false)
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    realize: function ({commit, state}, id) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_REALIZE_LOADING', true);

        return state.service.realize(id).then(response => {
            const model = Object.assign({}, response.data)

            commit('REPLACE_ITEM', model);
            commit('SET_ITEM', model);
            alert(commit, this.$t('request.save_is_successful'));
            commit('SET_ERRORS', {});
            commit('app/SET_LOADING', false, {root: true});
            commit('SET_REALIZE_LOADING', false);

            return model;
        }).catch((e) => {
            handleError(e, commit)
        })
    },
}
